const AP_SESSION_FLAG = 'ap_checkout_completed';

function initializeDrawerAfterpay() {
  const drawerElement = document.querySelector('cart-drawer');
  if (!drawerElement) return;

  // Listen for drawer mutations
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.target.hasAttribute('open')) {
        initializeAfterpay('cartDrawerAfterpay');
      }
    });
  });

  observer.observe(drawerElement, {
    attributes: true,
    attributeFilter: ['open']
  });
}

function showLoadingOverlay() {
  if (!document.getElementById('afterpay-loading-overlay')) {
    const overlay = document.createElement('div');
    overlay.id = 'afterpay-loading-overlay';
    overlay.style.position = 'fixed';
    overlay.style.inset = '0'; // top:0; right:0; bottom:0; left:0
    overlay.style.background = 'rgba(0,0,0,0.3)';
    overlay.style.zIndex = '9999';
    overlay.style.cursor = 'wait';
    overlay.style.pointerEvents = 'all';
    document.body.appendChild(overlay);
  }
  document.getElementById('afterpay-loading-overlay').style.display = 'block';
}

function hideLoadingOverlay() {
  const overlay = document.getElementById('afterpay-loading-overlay');
  if (overlay) overlay.style.display = 'none';
}

async function initializeAfterpay(containerId) {
  // Validate bundle state
  const bundleStateRaw = localStorage.getItem('personalised_bundle_state');
  let bundleState;
  try {
    bundleState = JSON.parse(bundleStateRaw);
  } catch (e) {
    console.warn('Invalid personalised_bundle_state');
    return;
  }

  if (!bundleState || !["60", "90"].includes(bundleState.frequency)) {
    console.log('Afterpay hidden due to frequency !== 60 or 90');
    return;
  }

  // Render button in specified container
  const wrapper = document.getElementById(containerId);
  if (!wrapper) return;
  const apCheckoutCompleted = sessionStorage.getItem(AP_SESSION_FLAG);
  wrapper.innerHTML = `
    <button
      id="afterpay-button"
      class="${apCheckoutCompleted === 'true' ? 'd-none' : ''}"
      style="
        width: 100%;
        padding: 12px;
        border: none;
        background: #272626;
        color: #b2fce3;
        font-size: 16px;
        border-radius: 9999px;
        cursor: pointer;
      "
    >
        Checkout with Afterpay
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="24px" height="24px">
          <path fill="#b2fce3" d="M44,24c0,11.044-8.956,20-20,20S4,35.044,4,24S12.956,4,24,4S44,12.956,44,24z" />
          <path fill="#000100"
            d="M23.913,36.113c-0.714,0.427-1.506,0.637-2.291,0.637c-0.771,0-1.534-0.196-2.235-0.602l-7.159-4.133	c-1.422-0.82-2.256-2.291-2.228-3.937c0.028-1.639,0.904-3.089,2.354-3.86l6.907-3.706c1.415-0.757,3.061-0.75,4.399,0.021	c1.268,0.736,2.059,2.073,2.109,3.58c0.028,0.967-0.729,1.779-1.695,1.807c-0.995,0.028-1.779-0.729-1.807-1.695	c-0.007-0.301-0.133-0.525-0.357-0.658c-0.28-0.161-0.651-0.147-0.995,0.035L14.008,27.3c-0.448,0.245-0.504,0.665-0.504,0.834	c-0.007,0.168,0.035,0.595,0.476,0.848l7.159,4.133c0.441,0.252,0.827,0.077,0.974-0.007c0.147-0.091,0.483-0.35,0.469-0.855	l-0.054-1.228c-0.025-0.558,0.581-0.919,1.06-0.632l1.849,1.107c0.207,0.124,0.342,0.348,0.343,0.59	C25.786,33.945,25.236,35.316,23.913,36.113z" />
          <path fill="#000100"
            d="M38,20.232c-0.028,1.639-0.911,3.082-2.361,3.86l-6.907,3.706c-0.708,0.378-1.464,0.567-2.214,0.567	c-0.757,0-1.499-0.196-2.165-0.574c-1.261-0.729-2.038-2.059-2.087-3.566c-0.028-0.967,0.729-1.779,1.695-1.807h0.107	c0.955,0,1.644,0.787,1.702,1.741c0.017,0.277,0.128,0.479,0.334,0.599c0.266,0.154,0.63,0.133,0.974-0.049l6.907-3.699	c0.455-0.245,0.504-0.665,0.511-0.834c0-0.175-0.042-0.595-0.483-0.848l-7.152-4.133c-0.441-0.252-0.834-0.077-0.974,0.007	c-0.147,0.091-0.483,0.343-0.469,0.855c0.031,0.441,0.057,0.803,0.078,1.1c0.04,0.57-0.582,0.945-1.067,0.645l-1.848-1.144	c-0.197-0.122-0.328-0.333-0.335-0.564c-0.046-1.551,0.423-3.047,1.842-3.897c1.408-0.841,3.096-0.855,4.525-0.035l7.152,4.133	C37.187,17.115,38.021,18.586,38,20.232z" />
        </svg>
    </button>
  `;

  document.getElementById('afterpay-button').addEventListener('click', async () => {
    showLoadingOverlay();

    const originUrl = window.location.href;

    try {
      // Get cart data from Shopify
      const res = await fetch('/cart.js');
      const cartData = await res.json();

      const items = cartData.items.map(item => ({
        name: item.product_title,
        sku: item.sku || '',
        quantity: item.quantity,
        price: {
          amount: (item.price / 100).toFixed(2),
          currency: 'AUD',
        }
      }));

      const total = (cartData.total_price / 100).toFixed(2);
      if (parseFloat(total) > 2000) {
        alert('Order value exceeded the maximum payment limit with Afterpay.');
        return;
      }

      const AFTERPAY_GATEWAY_API_URL = 'https://lvi88fhcpg.execute-api.ap-southeast-2.amazonaws.com/prod/afterpay-gateway';

      // Create afterpay token
      const tokenRes = await fetch(`${AFTERPAY_GATEWAY_API_URL}/afterpay/checkout`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          amount: total,
          currency: 'AUD',
          popupOriginUrl: originUrl,
          items,
          mode: 'express'
        })
      });

      if (!tokenRes.ok) {
        throw new Error('Failed to create Afterpay token');
      }

      const data = await tokenRes.json();

      if (!data?.token) {
        throw new Error('Missing token');
      }

      // Redirect to central page (auto-launch)
      const q = new URLSearchParams({
        token: data.token,
        autostart: '1',
        source: 'review'
      });
      window.location.href = `/pages/pay-with-afterpay?${q.toString()}`;
    } catch (e) {
      if (DEBUG) console.error('Afterpay start error:', e);
      alert('There was an error starting Afterpay.');
    } finally {
      hideLoadingOverlay();
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', () => {
  // Initialize main cart button
  initializeAfterpay('afterpay-button-wrapper');
  
  // Set up drawer initialization
  initializeDrawerAfterpay();
});

// Handle section renders
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('cart-drawer')) {
    initializeDrawerAfterpay();
  }
});